export const fmtUSD = (n) => `$${Number(n || 0).toFixed(2)}`;
